import * as React from "react";
import * as cn from "classnames/bind";
import * as styles from "./style.css";

const cx = cn.bind(styles);

const checkboxCn = () =>
    cx({
        checkBoxWrap: true,
    });

const checkBoxSpanCn = (isChecked: boolean) =>
    cx({
        checkBoxWrapSpan: true,
        checkBoxWrapSpanSelected: isChecked,
        fas: isChecked,
        "fa-check": isChecked,
    });

interface CheckboxProps {
    onClick: () => void;
    label?: string;
    checked: boolean;
}

const Checkbox = ({ onClick, label, checked }: CheckboxProps) => {
    return (
        <div className={styles.checkBoxDiv}>
            <label className={checkboxCn()} onClick={onClick}>
                {label}
                <div className={checkBoxSpanCn(checked)} />
            </label>
        </div>
    );
};

export { Checkbox };
